<template>

    <div>

        <div class="row g-3 mb-4">

            <div class="col-24 col-md-6">
                <input type="text"
                       class="form-control new-list-group-field"
                       placeholder="Sök anställd, massör eller mottagning"
                       v-model="settings.query.text"
                >
            </div>

            <div class="col-12 col-md-3">
                <datepicker-new
                    input-class="form-control new-list-group-field"
                    :clear-button="true"
                    clear-button-icon="fa fa-times"
                    placeholder="Från datum"
                    :language="former.datepicker.locale"
                    :use-utc="true"
                    :monday-first="true"
                    :format="former.formerDateFormat"
                    v-model="settings.query.treatment_at_from"
                />
            </div>

            <div class="col-12 col-md-3">
                <datepicker-new
                    input-class="form-control new-list-group-field"
                    :clear-button="true"
                    clear-button-icon="fa fa-times"
                    placeholder="Till datum"
                    :language="former.datepicker.locale"
                    :use-utc="true"
                    :monday-first="true"
                    :format="former.formerDateFormat"
                    v-model="settings.query.treatment_at_to"
                />
            </div>

            <div class="col-12 col-md-3">
                <select class="form-select new-list-group-field" v-model="settings.query.workplace">
                    <option :value="null">Arbetsplats</option>
                    <option :key="'w'+workplace.id" :value="workplace.id" v-for="workplace in workplaces">{{ workplace.title }}</option>
                </select>
            </div>

            <div class="col-12 col-md-5">
                <select class="form-select new-list-group-field" v-model="settings.query.type">
                    <option :value="null">På mottagning & arbetsplats</option>
                    <option value="internal">Endast mottagning</option>
                    <option value="external">Endast arbetsplats</option>
                </select>
            </div>

            <div class="col-24 col-md-4 d-flex justify-content-end">
                <button class="btn btn-primary btn-sm float-end" @click="openExportModal()">Exportera
                    <div class="tooltip-label">Ladda ner en excel med alla filtrerade behandlingar.</div>
                </button>
            </div>

        </div>

        <list ref="list" :settings="settings" :query.sync="settings.query" :useCookies="false">
            <div slot="item-row" slot-scope="props">
                <treatments-list-item-row
                    :treatment="props.item"
                    displayFrom="company"
                    @refresh="refresh()"
                />
            </div>
        </list>
    </div>

</template>

<script>
import lister from '../../../../shared/mixins/lister'
import former from '../../../../shared/mixins/former'

import TreatmentsListItemRow from './treatments-list-item-row'
import fetcher from '../../../../shared/mixins/fetcher'

export default {
    components: {
        TreatmentsListItemRow
    },

    mixins: [
        fetcher,
        lister,
        former
    ],

    props: {
        company_id: {
            required: true
        }
    },

    data () {
        return {
            workplaces: [],
            fetcher: {
                autoFill: [
                    'workplaces'
                ]
            },
            settings: {
                url: '/companies/' + this.company_id + '/treatments/list',
                query: {
                    text: '',
                    treatment_at_from: null,
                    treatment_at_to: null,
                    workplace: null,
                    type: null
                },
                columns: [
                    { column: 'treatment_at', name: 'Beh.datum', class: 'col-3', sortable: true, default: true },
                    { column: 'employee_name', name: 'Anställd', class: 'col-3', sortable: true },
                    { column: 'location', name: 'Beh. plats', class: 'col-4', sortable: false },
                    { column: 'clinic_name_person', name: 'Massör', class: 'col-3', sortable: true },
                    { column: 'duration', name: 'Längd', class: 'col-2', sortable: true },
                    { column: 'part_payment', name: 'Delbetalning', class: 'col-3', sortable: false },
                    { column: 'punched_by', name: 'Registrerad av', class: 'col-3', sortable: false },
                    { column: 'created_at', name: 'Reg.datum', class: 'col-2', sortable: true },
                    { column: 'buttons', name: '', class: 'col-1', sortable: false }
                ],
                bulk_actions: [],
                export_fields: [
                    { column: 'treatment_at', name: 'Behandlingsdatum' },
                    { column: 'employee.name', name: 'Anställd' },
                    { column: 'employeeWorkplace.title', name: 'Arbetsplats' },
                    { column: 'location', name: 'Behandlingsplats' },
                    { column: 'is_internal', name: 'På mottagning' },
                    { column: 'is_external', name: 'På arbetsplatsen' },
                    { column: 'clinic.name_person', name: 'Massör' },
                    { column: 'contract.subscription.duration.name', name: 'Längd' },
                    { column: 'part_payment_text', name: 'Delbetalning' },
                    { column: 'punched_by_text', name: 'Registrerad av' },
                    { column: 'created_at', name: 'Registreringsdatum' }
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/companies/' + this.company_id + '/employees'
        }
    }
}
</script>
